import axios from '../../utils/axios.js'

export const pageFind = (query) => axios.setAxiosGetPromise('view', query)
export const save = (query) => axios.setAxiosPostPromise('view/upload', query)
export const edit = (query) => axios.setAxiosPostPromise('view/edit_view', query)
export const checkViewName = (query) => axios.setAxiosGetPromise('view/checkViewName', query)
export const isBindRegion = (query) => axios.setAxiosGetPromise('view/isBindRegion', query)
export const remove = (query) => axios.setAxiosGetPromise('view/remove_view', query)
export const bindRegion = (query) => axios.setAxiosGetPromise('view/bindRegion', query)
export const unBind = (query) => axios.setAxiosGetPromise('view/unBind', query)
export const checkUpload = (query) => axios.setAxiosPostPromise('view/checkUpload', query)
export const updateRegion = (query) => axios.setAxiosGetPromise('view/updateRegion', query)
export const updateStatus = (query) => axios.setAxiosGetPromise('view/updateStatus', query)



// WEBPACK FOOTER //
// ./src/services/system/view.js